<app-navigation></app-navigation>
<button class="top-navi" routerLink="../../reports/assessments" mat-button>
  <mat-icon>arrow_back</mat-icon>Zurück
</button>
<mat-card class="card">
  <mat-card-content>
    <span class="h2">Assessments</span>
    <span class="top-buttons no-print">
      <button mat-button routerLink="../edit"><mat-icon>edit</mat-icon>Papier-Assessments verwalten</button>
    </span>

    <div class="buttons">
      @for (item of assessmentListMixed(); track $index) {
        @if (item.customId) {
          <button mat-raised-button (click)="onCustomAssessment(item.customId)">
            <h3>{{ item.shortName }}</h3>
            <p>{{ item.fullName }}</p>
          </button>
        } @else if (item.path) {
          <button mat-raised-button (click)="onStandardAssessment(item.path)">
            <h3>{{ item.shortName }}</h3>
            <p>{{ item.fullName }}</p>
          </button>
        }
      }
    </div>

    <div class="more-assessments">
      <p>
        Wir fügen regelmäßig weitere Assessments hinzu. Teilen Sie uns gerne Ihre Wünsche per
        <a href="https://forms.office.com/e/D5LRRX58Pe" target="_blank" rel="noopener">Umfrage</a> mit.
      </p>
    </div>
  </mat-card-content>
</mat-card>
